import React, { CSSProperties } from 'react'

import { blackStar, whiteStar } from "../../../../components/FeedbackOverview/SVG";
import { LabelModule2 } from '../../../../components/Modules/LabelModule2';

type StarStyle = {
    Style?: React.CSSProperties | undefined;
    PrimaryColor?: string | undefined;
    SecondaryColor?: string | undefined;
    Size?: number | undefined;
};

const RatingInput = ({
    data,
    labelStyle,
    ratingStyle,
    rating,
    handleRatingChange2,
    StarStyle,
    starBorderColor
}: {
    data: any,
    labelStyle: CSSProperties | undefined,
    ratingStyle: "Star" | "Numbers" | "Smiles" | undefined,
    rating: number,
    handleRatingChange2: Function,
    StarStyle: StarStyle | undefined,
    starBorderColor: string | undefined,
}) => {
    return (
        <div key={data.criteriaId}>
            <LabelModule2
                htmlFor={"normalInput"}
                children={
                    data.question
                        ? data.question
                        : "How would you rate your experience ?"
                }
                style={labelStyle}
            />
            <div>
                {ratingStyle == "Numbers" || data.ratingType == "Numbers" ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "4px",
                        }}
                    >
                        {Array(data.scale || 5).fill(1).map((num, index) => (
                            <div
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    minWidth: "35px",
                                    color: num + index <= rating ? "#FFF" : "#8E8E8E",
                                    borderRadius: "10px",
                                    border:
                                        num + index <= rating
                                            ? "2px solid var(--neutral-grey-100, #000)"
                                            : "2px solid var(--neutral-grey-100, #ECECEC)",
                                    background: num + index <= rating ? "#000" : "#fff",
                                    padding: "10px 12px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    boxSizing: "content-box",
                                }}
                                key={index}
                                onClick={(e) =>
                                    handleRatingChange2(e, data.criteriaId, num + index)
                                }
                            >
                                {num + index}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            ...StarStyle?.Style,
                        }}
                    >
                        {[1, 2, 3, 4, 5].map((star) => (
                            <div
                                style={{
                                    width: `${StarStyle?.Size}px` || "32px",
                                    height: `${StarStyle?.Size}px` || "32px",
                                    lineHeight: `${StarStyle?.Size}px` || "32px",
                                    cursor: "pointer",
                                }}
                                key={star}
                                onClick={(e) =>
                                    handleRatingChange2(e, data.criteriaId, star)
                                }
                            >
                                {star <= rating
                                    ? blackStar(
                                        StarStyle?.Size,
                                        StarStyle?.PrimaryColor,
                                        starBorderColor
                                    )
                                    : whiteStar(
                                        StarStyle?.Size,
                                        StarStyle?.SecondaryColor,
                                        starBorderColor
                                    )}
                            </div>
                        ))}
                    </div>
                )}
                {ratingStyle && ratingStyle !== "Star" && <div className={"ratingTextView"}>
                    <div className={"ratingText"} >
                        {data?.leftText || "Not likely"}
                    </div>
                    <div className={"ratingText"} >
                        {data?.rightText || "Very Likely"}
                    </div>
                </div>}
                {data.ratingType && data.ratingType !== "Star" && <div className={"ratingTextView"}>
                    <div className={"ratingText"} >
                        {data?.leftText || "Not likely"}
                    </div>
                    <div className={"ratingText"} >
                        {data?.rightText || "Very Likely"}
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default RatingInput